/**
 * Generates a decorated Fetch API that includes auth via JWT.
 *
 * The returned Fetch includes some optional configuration options
 * that handles the boilerplate of network connections:
 *
 * - jsonBody: Automatically convert body object to a string, apply JSON content type
 *
 * @param {String} jwt - User's JWT
 * @return {Function} - Fetch API with auth applied
 */
export default function getDecoratedFetch(jwt) {
  if (!jwt) throw new Error('Missing JWT in getDecoratedFetch')

  return (url, options = {}) => {
    const configHeaders = {}
    const { jsonBody, ...restOptions } = options

    if (jsonBody) {
      configHeaders['Content-Type'] = 'application/json'
    }

    return fetch(url, {
      method: 'GET',
      ...restOptions,
      headers: {
        ...(restOptions?.headers ?? {}),
        ...configHeaders,
        Authorization: `Bearer ${jwt}`, // Do not allow amending auth
      },
      body: jsonBody ? JSON.stringify(jsonBody) : restOptions.body,
    })
  }
}
